import React from "react";
import Icon from "./Icon";

// Icons/Core/error-warning-line
function Error(props) {
  const svgPathDParameter = "M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z";
  return (<Icon {...props} svgPathDParameter={svgPathDParameter} />);
}

export default Error;
